import React from "react";

class CBP extends React.Component {
  render() {
    const { state, setState, isEdit } = this.props;

    return (
      <>
        <div className="row">
          <div className="col-md-6">
            <label className="pb-1">Select Month</label>
            <input
              onChange={(event) => setState({ term: event.target.value })}
              value={state.term || ""}
              type="month"
              name="term"
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <label className="pb-1">Select Class</label>
            <select
              onChange={(event) => setState({ className: event.target.value })}
              value={state.className || ""}
              name="className"
              className="form-select form-control"
              required
            >
              <option value="">Select Class</option>
              <option value="Class IX">Class 9</option>
              <option value="Class X">Class 10</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <label className="pb-1">Event Start Date</label>
            <input
              onChange={(event) =>
                setState({ eventStartDate: event.target.value })
              }
              value={state.eventStartDate || ""}
              type="date"
              name="eventStartDate"
              className="form-control"
              required
            />
          </div>

          <div className="col-md-6">
            <label className="pb-1">Event End Date</label>
            <input
              onChange={(event) =>
                setState({ eventEndDate: event.target.value })
              }
              value={state.eventEndDate || ""}
              type="date"
              name="eventEndDate"
              className="form-control"
              required
            />
          </div>
        </div>
      </>
    );
  }
}

export default CBP;
